import cn from 'classnames';

import Byline from 'components/byline/Byline';
import Link from 'components/link/Link';
import OptionsModal from 'components/options-modal/OptionsModal';

import { IPageFooter } from 'source/NFR.types';

const PageFooter: React.FC<IPageFooter> = ({ byline, download, share }) => (
  <div className="page-footer">
    <div className="page-footer--byline-wrapper">
      {!!byline?.items?.length && <Byline {...byline} />}

      <div className="page-footer--links">
        {download && (
          <div className="page-footer--download-link">
            <Link {...download} icon="download-small" />
          </div>
        )}
        {share && (
          <div className={cn('page-footer--share', download && 'page-footer--share--with-seperator')}>
            <OptionsModal theme="isPageFooter" {...share}></OptionsModal>
          </div>
        )}
      </div>
    </div>
  </div>
);

PageFooter.displayName = 'PageFooter';

export default PageFooter;
